import { render, staticRenderFns } from "./payFeeOrderConfirm.vue?vue&type=template&id=0b005463&scoped=true"
import script from "./payFeeOrderConfirm.vue?vue&type=script&lang=js"
export * from "./payFeeOrderConfirm.vue?vue&type=script&lang=js"
import style0 from "./payFeeOrderConfirm.vue?vue&type=style&index=0&id=0b005463&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b005463",
  null
  
)

export default component.exports